import { useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { ButtonBorderRadius } from '@apply/components/src/components/controls/Button';
import { StandardModalDemo } from './components/StandardModalDemo/StandardModalDemo';
import { WizardModalDemo } from './components/WizardModalDemo/WizardModalDemo';
import { StandardLoanModal } from '../../../../loans/modals/v2/StandardLoanModal/StandardLoanModal';
import { BorrowerModals } from '../../../../borrowers/common/BorrowerComponents';

/** TEMP: Demo Harness designed to show off new Modal capabilities. Remove once the modal is in use. */
export const ModalDemo = () => {
    const [isStandardModalOpen, set_isStandardModalOpen] = useState(false);
    const [isWizardModalOpen, set_isWizardModalOpen] = useState(false);
    const [isLoanModalOpen, set_isLoanModalOpen] = useState(false);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '8px' }}>
                <Button
                    id='openStandardModalTest'
                    handleClick={() => set_isStandardModalOpen(true)}
                    theme={ButtonTheme.SectionHeaderBarButton_Blue}
                    height='32px'
                    borderRadius={ButtonBorderRadius.Small}
                >
                    Standard Modal
                </Button>
                <Button
                    id='openWizardModalTest'
                    handleClick={() => set_isWizardModalOpen(true)}
                    theme={ButtonTheme.SectionHeaderBarButton_Blue}
                    height='32px'
                    borderRadius={ButtonBorderRadius.Small}
                >
                    Wizard Modal
                </Button>
                <Button
                    id='openLoanModalTest'
                    handleClick={() => set_isLoanModalOpen(true)}
                    theme={ButtonTheme.SectionHeaderBarButton_Blue}
                    height='32px'
                    borderRadius={ButtonBorderRadius.Small}
                >
                    Loan Modal
                </Button>
            </div>
            <StandardModalDemo
                isOpen={isStandardModalOpen}
                onClose={() => set_isStandardModalOpen(false)}
            />
            <WizardModalDemo
                isOpen={isWizardModalOpen}
                onClose={() => set_isWizardModalOpen(false)}
            />
            <StandardLoanModal
                isOpen={isLoanModalOpen}
                onClose={() => set_isLoanModalOpen(false)}
            />
            {/* The Loan Modal's Borrower step opens EditEntityModal (Add / Edit entity), which the page has to render */}
            <BorrowerModals />
        </>
    );
};
